import React, { useState, useEffect } from "react";
import SchedulingWrapper from "../../../../features/scheduling/components/index.style";
import { useDispatch, useSelector } from "react-redux";
import { convertSchedulingEventsFromCalender } from "../../../util/helpers";
import EventModal from "../../../../features/scheduling/components/EventModal";
import {
  editSchedulingEvent,
  deleteSchedulingEvent,
} from "../../../../features/scheduling/schedulingSlice";
import moment from "moment";

const EditEventModal = (props) => {
  const { record, orders, visible, hide, onSaveEventCompleted } = props;
  const [activeEvent, setActiveEvent] = useState({});

  const patientId = record && record.order && record.order.patient.id;

  const branchId = record && record.order && record.order.patient.branch;

  const editLoading = useSelector(
    (state) => state.pendingActions["scheduling/edit"]
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (record) {
      const startDate = moment(record.date);
      const start = startDate.toDate();
      const end = startDate.add(record.duration_minutes, "minutes").toDate();
      const converted = { ...record, start, end };
      setActiveEvent(converted);
    }
  }, [record]);

  const changeEvent = async (changed, start, end) => {
    setActiveEvent({ ...changed, start, end });
    const converted = convertSchedulingEventsFromCalender({
      ...changed,
      start,
      end,
    });
    const params = {
      patientId: patientId,
      branchId: branchId,
      schedulingEvent: { deleted: converted.deleted, new: { ...converted } },
    };
    await dispatch(editSchedulingEvent(params));
    await onSaveEventCompleted();
    setActiveEvent({});
  };

  const handleCancel = (e) => {
    hide();
    setActiveEvent({});
  };

  const submitEvent = async (e) => {
    const converted = convertSchedulingEventsFromCalender(activeEvent);
    const params = {
      patientId: patientId,
      branchId: branchId,
      schedulingEvent: {
        deleted: !activeEvent.ghost ? converted.deleted : null,
        new: { ...converted },
        deleted_replacement: activeEvent.ghost ? converted.deleted : null,
      },
    };

    await dispatch(editSchedulingEvent(params));
    await onSaveEventCompleted();
    setActiveEvent({});
  };

  const removeEvent = async (e) => {
    hide();
    const params = {
      patientId: patientId,
      branchId: branchId,
      schedulingEvent: { deleted: record ? record.id : null },
    };
    await dispatch(deleteSchedulingEvent(params));
    await onSaveEventCompleted();
    setActiveEvent({});
  };

  const changeActiveEvent = (newEvent) => {
    setActiveEvent(newEvent);
  };

  const onChosenEmployee = (employee) => {
    const client_salary_tariff_id =
      activeEvent?.order?.client?.salary_tariff_id;
    setActiveEvent({
      ...activeEvent,
      employee: employee,
      employee_id: employee.id,
      tariff_id: client_salary_tariff_id || employee.tariff_id,
      oncall: false,
      use_employee_tariff:
        client_salary_tariff_id || employee?.tariff ? true : false,
    });
  };

  const onRemoveEmployee = () => {
    setActiveEvent({
      ...activeEvent,
      employee: null,
      tariff_id: null,
      employee_id: null,
    });
  };

  const onTariffChanged = (val) => {
    setActiveEvent({
      ...activeEvent,
      tariff_id: val,
    });
  };
  const onUseEmployeeTariffChanged = (val) => {
    const clientTariffId = activeEvent?.order?.client?.salary_tariff_id;
    setActiveEvent({
      ...activeEvent,
      use_employee_tariff: val,
      tariff_id: clientTariffId || activeEvent?.employee?.tariff?.id,
    });
  };
  const onTransportationChanged = (val) => {
    setActiveEvent({
      ...activeEvent,
      transportation_cost: val,
    });
  };

  const onOncallChange = (val) => {
    setActiveEvent({
      ...activeEvent,
      oncall: val,
    });
  };

  return (
    <SchedulingWrapper>
      <EventModal
        activeEvent={activeEvent}
        changeActiveEvent={changeActiveEvent}
        orders={orders}
        onChosenEmployee={onChosenEmployee}
        onRemoveEmployee={onRemoveEmployee}
        onTariffChanged={onTariffChanged}
        onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
        onTransportationChanged={onTransportationChanged}
        onOncallChange={onOncallChange}
        visible={visible}
        submitEvent={submitEvent}
        handleCancel={handleCancel}
        removeEvent={removeEvent}
        mode={"edit"}
        changeEvent={changeEvent}
        editLoading={editLoading}
        originalEmployeeId={null}
        patient={
          record &&
          record.order && {
            ...record.order.patient,
            geo: {},
            care_demands:
              (record.order.patient.care_demands &&
                record.order.patient.care_demands.map((i) => i.id)) ||
              [],
          }
        }
      />
    </SchedulingWrapper>
  );
};

export default EditEventModal;
